export default "__VITE_ASSET__CFy7Ktzu__"